import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postStudio = async ({ payload }) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: `/studio`, data: payload });

  return data;
};

export default postStudio;
